module.exports = __webpack_public_path__ + "prj_04.d1ea8f6a.jpeg";